import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { UserRole } from '@/types';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useAuthStore();
  
  // Admins and Superadmins can access these routes
  if (user?.role === UserRole.ADMIN || user?.role === UserRole.SUPERADMIN) {
    return <>{children}</>;
  }
  
  // Redirect non-admin users to dashboard
  return <Navigate to="/dashboard" replace />;
};

export default AdminRoute;
